import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Detalii comandă',
  sections: {
    driver_info: 'Info curier',
    order_info: 'Info comandă',
    price_info: 'Info preț',
    adjustments: 'Ajustări',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'La pachet',
    [ORDER_METHODS.delivery]: 'Livrare',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Serviciu la cameră',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Serviciu la masă',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'Nr. cameră',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'Nr. masă',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Această comandă este în așteptarea aprobării',
    [FULFILLMENT_STATUSES.reviewed]: 'Această comandă este în așteptarea aprobării',
    [FULFILLMENT_STATUSES.accepted]: 'Această comandă este în curs de procesare',
    [FULFILLMENT_STATUSES.preparing]: 'Această comandă este în curs de procesare',
    [FULFILLMENT_STATUSES.ready]: 'Această comandă este gata de ridicare de către client',
    [FULFILLMENT_STATUSES.on_delivery]: 'Această comandă este în curs de livrare',
    [FULFILLMENT_STATUSES.picked]: 'Această comandă a fost finalizată cu succes',
    [FULFILLMENT_STATUSES.rejected]: 'Această comandă a fost respinsă și rambursată',
    default: 'Această comandă a fost finalizată cu succes',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Solicitat de client',
    [REFUND_REASONS.Reclamation]: 'Reclamație',
    [REFUND_REASONS.CommunicationError]: 'Eroare de comunicare',
    [REFUND_REASONS.Other]: 'Altul',
    [REFUND_REASONS.Dispute]: 'Litigiu client',
    dispute_win: 'Litigiu client câștigat',
    null: '',
    undefined: '',
  },
  labels: {
    order_note: 'Notă comandă',
    discount: 'Reducere',
    driver_name: 'Nume curier',
    driver_phone_number: 'Telefon curier',
    pin_code: 'PIN',
    invoice_payment: 'Plată prin factură',
    paid_in_cash: 'Plată în numerar',
    customer_paid_online: 'Clientul a plătit online',
    phone: 'Tel',
    email: 'Email',
    points_used: 'Această comandă include o recompensă de puncte de fidelitate răscumpărată de un client fidel',
    delivery: 'Livrare',
    pickup: 'Ridicare',
    original: 'Original',
    delivery_fee: 'Taxă de livrare',
    tip: 'Bacșiș',
    service_fee: 'Procesare online',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'Comision PayPal',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Reducere procentuală pe total aplicată',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Reducere procentuală pe produse aplicată',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Reducere valorică pe produse aplicată',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Reducere valorică pe total aplicată',
      [OFFER_KIND.BOGO]: 'BOGO aplicat',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo la jumătate de preț aplicat',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Produs gratuit din produse aplicat',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Produs gratuit din total aplicat',
      GiftCard: 'Card cadou aplicat',
      Reward: 'Puncte de loialitate aplicate',
      CashbackAccount: 'Puncte de loialitate aplicate',
      PromoCodeComponent: 'Promoție aplicată',
      Offer: 'Ofertă aplicată',
    },
    total_discount: 'Promoție aplicată',
    tax: 'Taxe',
    total: 'Total',
    today: 'Astăzi',
  },
  schedule: {
    header: 'Programat pentru {{date}}, {{time}}',
    text: 'Vă vom reaminti când este timpul să începeți pregătirea comenzii',
  },
};
